import React, {useEffect, useRef} from 'react';
import {fetchReports} from '../../store/my-reports.actions';
import {connect} from 'react-redux';
import useMedia from '../../../../hooks/useMedia';

const InfiniteScroll = ({children, actions} ) => {

  // add loader reference
  const loader = useRef(null);

  const containerIntersector = useMedia(['(max-width: 576px)'], [
    document.querySelector('body')
  ], document.querySelector('#grid-container'));

  // here we handle what happens when user scrolls to Load More div
  // in this case we just update page variable
  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      actions.fetchReports()
    }
  };

  useEffect(() => {
    const options = {
      root: containerIntersector,
      rootMargin: "0px",
      threshold: 0
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) {
      observer.observe(loader.current);
    }
    return () => observer.disconnect();
  }, [containerIntersector]);

  return (
    <>
      {children}
      <div className="loading" ref={loader} style={{display: 'block'}} >
        <h2>&nbsp;</h2>
      </div>
    </>
  )
};

const mapStateToProps = (state) => ({
  loading: state.myReportsReducers.loading,
  loadedAmount: state.myReportsReducers.loadedAmount,
  total: state.myReportsReducers.total,
});

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchReports: (payload) => dispatch(fetchReports(payload)),
    },
    dispatch
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfiniteScroll);
